import EsgGuide from "../../components/esg-guide/Esg-guide";
import EsgLayout from "../../components/esg-guide/Esg-layout";
import Layout from "../../components/layout/Layout";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const EsgGuidePage = () => {
  return (
    <>
      <Layout
        parent={"홈"}
        sub={"ESG자료실"}
        pageTitle={SeoMeta.esgLibrary.title}
        pageDesc={SeoMeta.esgLibrary.description}
        pageKeyword={SeoMeta.esgLibrary.keywords}
      >
        <EsgLayout>
          <div className="container">
            <EsgGuide />
          </div>
        </EsgLayout>
      </Layout>
    </>
  );
};
export default EsgGuidePage;
